import type {ReactNode} from 'react';
import {Button} from '@features/ui/components/Button';
import {Link} from '@tanstack/react-router';
import type React from 'react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  subtitle: string;
  action?: {
    label: string;
    href: string;
    onClick?: () => void;
  };
};

export function EmptyState({icon, title, subtitle, action}: EmptyStateProps) {
  return (
    <div className='mx-auto flex w-full max-w-sm flex-col items-center justify-center pb-16 pt-24'>
      {icon && (
        <div className='mb-1.5 text-gray-400' aria-hidden='true'>
          {icon}
        </div>
      )}
      <div className='text-center text-[22px] font-semibold leading-[30px] text-gray-400'>
        {title}
      </div>
      <div className='mt-2 text-center text-sm font-medium text-gray-400'>
        {subtitle}
      </div>
      {action && (
        <Link to={action.href}>
          <Button
            variant='secondary'
            size='sm'
            className='mt-4 inline-flex h-auto w-auto items-center justify-center self-center'
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        </Link>
      )}
    </div>
  );
}
